module.exports = __webpack_public_path__ + "img/hyu_gallery8.90913de6.jpg";